import { gql } from '@apollo/client';

export const CREATE_LECTURE_MATERIAL = gql`
  mutation insert_lecture_material($objects: [lecture_material_insert_input!]!) {
    insert_lecture_material(objects: $objects) {
      affected_rows
    }
  }
`;

export const LECTURE_MATERIALS = gql`
  subscription lecture_materials($where: lecture_material_bool_exp, $order_by: [lecture_material_order_by!]) {
    lecture_material(where: $where, order_by: $order_by) {
      content
      lecture_material_category {
        name
      }
      title
      id
    }
  }
`;

export const UPDATE_LECTURE_MATERIAL = gql`
  mutation update_lecture_material($where: lecture_material_bool_exp!, $_set: lecture_material_set_input) {
    update_lecture_material(where: $where, _set: $_set) {
      affected_rows
    }
  }
`;

export const DELETE_LECTURE_MATERIAL = gql`
  mutation delete_lecture_material($where: lecture_material_bool_exp!) {
    delete_lecture_material(where: $where) {
      affected_rows
    }
  }
`;

export const LECTURE_MATERIAL = gql`
  query lecture_material($where: lecture_material_bool_exp) {
    lecture_material(where: $where) {
      content
      id
      attachments
      updated_at
      title
      lecture_material_category {
        name
        id
      }
      batch_subject_configuration {
        subject {
          code
          name
        }
        course_semester {
          course {
            name
          }
        }
        batch {
          name
        }
        subject {
          name
        }
      }
    }
  }
`;

export const LECTURE_MATERIAL_ATTACHMENTS_UPLOAD_URLS = gql`
  query lectureMaterialAttachmentsUploadURLs($data: LectureMaterialAttachmentsUploadURLsInput!) {
    lectureMaterialAttachmentsUploadURLs(data: $data) {
      id
      url
    }
  }
`;
